module.exports = __webpack_public_path__ + "img/wave2.6c6bb28d.svg";